import { useNavigate, useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import {
  ProjectManagementProjectDetailsPageUnassignSingleEmployeeModalPageDocument,
  ProjectPeopleDataCollectionDocument,
  UnassignProjectWorkerDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { LoadingState } from 'modules/project_management/components/LoadingState'
import SingleActionModal from 'modules/project_management/components/modals/SingleActionModal'

const UnassignSingleEmployeeModalPage = () => {
  const { id, employeeId, projectWorkerId } = useParams()

  const navigate = useNavigate()

  const { loading: loadingQuery, data } = useQuery(
    ProjectManagementProjectDetailsPageUnassignSingleEmployeeModalPageDocument,
    {
      variables: { employeeId: Number(employeeId), projectId: Number(id) },
    }
  )

  const [unassign, { loading }] = useMutation(UnassignProjectWorkerDocument, {
    extractorFn: (mutationData) =>
      mutationData.projectManagementMutations.unassignProjectmanagementProjectWorker,
    refetchQueries: [ProjectPeopleDataCollectionDocument],
  })

  if (loadingQuery) return <LoadingState />

  const canAssignEmployees =
    data?.projectManagement?.projectsConnection?.nodes[0]?._policies?.assignUnassignProjectWorkers
      ?.can ?? false

  if (!canAssignEmployees) return null

  const employeeName = data?.employees?.employee?.fullName || ''

  const onSubmit = async () => {
    await asyncAction(() => unassign({ variables: { projectWorkerId: Number(projectWorkerId) } }), {
      successFlash: true,
      successMessage: i18n.t('common.saved_successfully'),
      errorFlash: true,
    })

    onClose()
  }

  const onClose = () => {
    navigate(-1)
  }

  const description = (
    <Text size="300">
      {i18n.tView('project_management.modals.unassign_single_employee.description', {
        project_name: (
          <Text size="300" weight="bold">
            {employeeName}
          </Text>
        ),
      })}
    </Text>
  )

  return (
    <SingleActionModal
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
      title={i18n.t('project_management.modals.unassign_single_employee.title')}
      description={description}
      iconName={'delete-cross'}
      submitButton={i18n.t('project_management.modals.unassign_single_employee.submit')}
    />
  )
}

export default UnassignSingleEmployeeModalPage
